import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Condolences from './components/Condolences';
import Contact from './components/Contact';
import Admin from './components/Admin';
import './App.css';

const EVENT_DETAILS = { personName: 'Dr. Ernest Hew' };

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app">
        <Routes>
          {/* Admin route without navbar */}
          <Route 
            path="/admin/*" 
            element={<Admin />} 
          />
          
          {/* All other routes with navbar */}
          <Route 
            path="*" 
            element={
              <>
                <Navbar />
                <main className="main-content">
                  <Routes>
                    <Route 
                      path="/" 
                      element={<Home eventDetails={EVENT_DETAILS} />} 
                    />
                    <Route 
                      path="/condolences" 
                      element={<Condolences />} 
                    />
                    <Route 
                      path="/contact" 
                      element={<Contact />} 
                    />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </main>
                <footer className="footer">
                  <div className="container">
                    <p className="footer-text">
                      In loving memory of Dr. Ernest Milton Hew
                    </p>
                  </div>
                </footer>
              </>
            } 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
